function prepareBreadcrumbs(pageCrumb) {
  return {
    text: pageCrumb.title,
    link: `/${pageCrumb.slug}`,
    hidden: !pageCrumb.is_active || pageCrumb.is_private
  };
}
export {
  prepareBreadcrumbs as default
};
